import styled from 'styled-components';
import { colors } from 'Constants';

export default styled.div`
  cursor: pointer;
  user-select: none;
  position: relative;
  width: 24px;
  height: 12px;

  ::after,
  ::before {
    content: '';
    position: absolute;
    background-color: ${colors.text};
    height: 2px;
    left: 0;
    right: 0;
    transition: 0.2s all;
  }

  ::after {
    top: ${props => (props.selected ? '5px' : 0)};
    ${props => props.selected && 'transform: rotate(45deg);'}
  }

  ::before {
    bottom: ${props => (props.selected ? '5px' : 0)};
    ${props => props.selected && 'transform: rotate(-45deg);'}
  }
`;
